import {get,post} from './httpApi';
import {getUserId} from '@/utils/auth'
/*获取名人动态列表*/
export function dynamicPageForShop(data){
    return new Promise((reslove,reject)=>{
        get('/dynamic/noJwt/dynamicPageForShop',{
            ...data
            /*userId:getUserId()*/
        }).then(res=>{
            reslove(res)
        }).catch(err=>{
            reject(err)
        })
    })
}
/*获取动态列表*/
export function dynamicPage(data){
    return get('/dynamic/noJwt/dynamicPage',{
        ...data
    })
}

/*获取动态详情*/
export function getDynamicInfo(data){
    return get('/dynamic/noJwt/getDynamicInfo',{
        ...data
    })
}
/*获取动态回复列表*/
export function getReplyList(data) {
    return get('/dynamic/noJwt/replyList',{
        ...data
    })
}
/*发布动态回复*/
export function addDynamic(data) {
    return post('/dynamic/addDynamic',{
        ...data
    })
}
/*点赞動態*/
export function fabulous(data) {
    return get('/dynamic/fabulous',{
        ...data
    })
}